import * as THREE from 'three';
import { Object3D } from "./Viewer.Object3D.js";


class Support extends Object3D {
    constructor(fixity, material) {
        super();

        this.material = material;

        // const ax = new THREE.AxesHelper();
        // this.add( ax );

        const pyramidGeometry = new THREE.ConeGeometry( 1, 1, 4);
        const pyramid = new THREE.Mesh( pyramidGeometry, this.material );
        pyramid.position.set( 0, 0, -1/2 );
        pyramid.rotateX( Math.PI / 2 );
        pyramid.rotateY( Math.PI / 4 );

        const sphereGeometry = new THREE.SphereGeometry( 1 / 4 , 8, 8);
        const sphere = new THREE.Mesh( sphereGeometry, this.material );

        const plateGeometry = new THREE.BoxGeometry( 1.5, 1.5, 1 / 4  );
        const plate = new THREE.Mesh( plateGeometry, this.material );
        // const plate2 = new THREE.Mesh( plateGeometry, this.material );
        plate.position.set(0, 0, - 1 * 1.3);

        if (fixity.x === 'fixed' && fixity.z === 'free' && fixity.ry === 'free') {
            this.add( sphere );
            this.add( pyramid );
            this.add( plate );
            this.rotateY( Math.PI / 2 );
        } else if (fixity.x === 'free' && fixity.z === 'fixed' && fixity.ry === 'free') {
            this.add( sphere );
            this.add( pyramid );
            this.add( plate );
        } else if (fixity.x === 'fixed' && fixity.z === 'fixed' && fixity.ry === 'free') {
            this.add( sphere );
            this.add( pyramid );
        } else if (fixity.x === 'fixed' && fixity.z === 'free' && fixity.ry === 'fixed') {
            this.add(plate);
            plate.position.set(0, 0, - 1 / 2);

            const plate2 = new THREE.Mesh( plateGeometry, this.material );
            this.add(plate2);
            plate2.position.set(0, 0, -1 / 8);
            this.rotateY( Math.PI / 2 );
        } else if (fixity.x === 'free' && fixity.z === 'fixed' && fixity.ry === 'fixed') {
            this.add(plate);
            plate.position.set(0, 0, - 1 / 2);

            const plate2 = new THREE.Mesh( plateGeometry, this.material );
            this.add(plate2);
            plate2.position.set(0, 0, -1 / 8);
        } else if (fixity.x === 'fixed' && fixity.z === 'fixed' && fixity.ry === 'fixed') {
            this.add(plate);
            plate.position.set(0, 0, -1 / 8);
        }//else if (fixity.x === 'free' && fixity.z === 'free' && fixity.ry === 'fixed') {
        // TODO: Add support for this case
        //     console.log('FFR')
        // } else {
        //     console.log('Free')
        // }

        this.setScale( 0.2 );
    }

    setScale( scaleFactor ) {
        this.scale.set( scaleFactor, scaleFactor, scaleFactor );
    }

    setColor( color ) {
        this.material.color.set( color );
    }
}

export { Support };